/**
 * Mock data for development/testing
 * Provides pre-filled answers for all questions
 */

export const MOCK_ANSWERS = {
  // Demographics
  'state': 'SP',
  'age': '28',
  'income-source': 'contratado ou contratada CLT',
  'scholarity': 'superior completo',
  'family-income': '7.272,01 a 12.120,00',
  'race': 'parda',
  'gender': 'homem',
  'sexual-orientation': 'heterossexual',

  // Beer types
  'common-beer-brands': {
    selections: ['heineken', 'brahma', 'stella artois'],
    otherText: ''
  },
  'common-beer': 'todas as categorias',

  // Beer consumption
  'beer-relationship': {
    selections: ['nenhuma'],
    otherText: ''
  },
  'other-drinks': {
    selections: ['vinho', 'gim'],
    otherText: ''
  },

  // Beer preferences (ratings)
  'beer-drinks-preferences-rating': {
    'em-um-churrasco': 5,
    'bar-com-os-amigos-ou-happy-hour': 4,
    'em-uma-comemoracao': 4,
    'em-um-jantar-em-casa': 3,
    'em-um-encontro': 3,
    'em-uma-noitada-balada': 4,
    'carnaval-festival': 5,
    'em-evento-esportivo': 5,
    'sozinho-em-casa': 3,
  },
  'beer-preferences-rating': {
    'em-um-churrasco': 3,
    'bar-com-os-amigos-ou-happy-hour': 4,
    'em-uma-comemoracao': 5,
    'em-um-jantar-em-casa': 4,
    'em-um-encontro': 4,
    'em-uma-noitada-balada': 3,
    'carnaval-festival': 3,
    'em-evento-esportivo': 2,
    'sozinho-em-casa': 4,
  },
  'beer-attributes-ranking': {
    selections: ['sabor', 'preco', 'marca', 'disponibilidade'],
    order: ['sabor', 'preco', 'disponibilidade', 'marca']
  },

  // Craft beer
  'first-craft-style': 'ipa',
  'more-frequent-styles': {
    selections: ['ipa', 'neipa / juicy ipa', 'pilsen'],
    otherText: ''
  },
  'why-dont-try-craft-beer': 'acho muito caras',

  // Beer events
  'went-to-beer-event': 'já fui, mas poucas vezes',
  'why-never-went-to-beer-event': 'preço das cervejas',
  'beer-event-price-range': 'até 200',
  'beer-event-price-range-without-consumption': 'até r$ 50',
  'beer-event-most-valued-thing': {
    selections: ['atrações musicais', 'opções de alimentação'],
    otherText: ''
  },

  // Beer travel
  'beer-travel': 'ja fui, mas não é recorrente',
  'beer-travel-no-interest': {
    selections: ['Custo alto', 'não tenho tempo de viajar'],
    otherText: ''
  },
  'beer-travel-already-done': 'ambos',
  'beer-travel-interest': 'brasil',
  'beer-travel-most-important': {
    selections: ['conhecer cervejas locais', 'viver uma experiência típica / cultural', 'visitas à produção'],
    otherText: ''
  },

  // Beer content
  'beer-content': 'sim',
  'beer-content-source': {
    selections: ['instagram', 'indicações-de-amigos', 'youtube'],
    otherText: ''
  },
  'beer-content-beer-club': 'não, mas assinaria',
  'beer-content-beer-club-value': 'até 150',

  // Beer behavior
  'beer-listening-styles': {
    selections: ['rock', 'mpb', 'jazz'],
    otherText: ''
  },
  'beer-adquisition-channels': {
    selections: ['supermercados', 'bares e lojas especializados', 'aplicativos de entrega'],
    order: ['supermercados', 'bares e lojas especializados', 'aplicativos de entrega']
  },
  'beer-adquisition-considerations': {
    selections: ['custo x benefício', 'estilo da cerveja', 'preço'],
    otherText: ''
  },
  'beer-adquisition-packaging': 'lata',

  // Non-alcohol beer
  'non-alcohol-beer-opinion': 'acho bom',
  'non-alcohol-beer-consumption': 'sim, mas não consumo com frequência',
  'non-alcohol-beer-reasons': {
    selections: ['quando vou dirigir', 'gosto do sabor'],
    otherText: ''
  },
  'non-alcohol-beer-brands': {
    selections: ['heineken zero', 'amstel 0.0', 'brahma zero'],
    otherText: ''
  },
  'non-alcohol-beer-favorites': {
    selections: ['heineken zero', 'amstel 0.0'],
    otherText: ''
  },
  'non-alcohol-beer-no-interest': {
    selections: ['não gosto do sabor', 'acho muito caras'],
    otherText: ''
  },
  'non-alcohol-beer-advices': {
    selections: ['preços mais baixos', 'estilos diferentes'],
    otherText: ''
  },
  'non-alcohol-beer-dosage': 'até 2 doses',

  // Drinking habit
  'beer-drinking-dosage': 'até 4 doses',
  'other-drinking-dosage': 'até 2 doses',
  'alcohol-consumption': 'moderado',
  'alcohol-reduction-measures': {
    selections: ['sim, adotando dias ou períodos sem bebida alcoólica', 'sim, fazendo zebra striping (intercalando 1 bebida alcoólica com outra não alcoólica)'],
    otherText: ''
  },
  'beer-budget': 'entre R$ 201,00 e R$ 300,00',
  'other-drinks-budget': 'até R$ 100,00',
  'session-beer-taxes': 'a favor',

  // User info
  'first-name': 'João',
  'email': 'joao.silva@example.com',
};

/**
 * Check if we're in development mode
 */
export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development' ||
         window.location.hostname === 'localhost' ||
         window.location.search.includes('devmode=true');
};
